export const UNLOCK_FULL_VERSION_IMAGE_URL =
  'https://cdn.helixa.ai/images/workspace/free_trial.png';
